<template>
  <template v-if="messageType === 'text'">
    <div class="ui-ai-conversation-message__text">
      {{ message.content }}
    </div>
  </template>
  <template v-else-if="messageType === 'examples'">
    <div v-if="data.message" class="ui-ai-conversation-message__text">
      {{ data.message }}
      <p v-for="question in data.questions" :key="question">- {{ question }}</p>
    </div>
    <UIAIConversationExamples
      v-if="isLast"
      :examples="data.examples"
      @click:example="handleClickExample"
    />
  </template>
  <template v-else-if="messageType === 'wizard'">
    <strong>{{ data.wizardName }}</strong>
    <div class="ui-ai-conversation-message__text">
      {{ data.description }}
    </div>
    <AIAgentWizard
      :name="data.wizardName"
      :structure="data.wizardStructure"
      :disable="!isLast"
    />
    <div class="ui-ai-conversation-message__text">
      Feel free to ask me to change something?
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { AIMessage } from '@types'

import { UIAIConversationExamples } from '@ui/ai'

import AIAgentWizard from './AIAgentWizard.vue'

type Props = {
  message: AIMessage
  isLast: boolean
}

type Emits = {
  (e: 'click:example', message: string): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const data = computed(() => {
  try {
    return JSON.parse(props.message.content)
  } catch {
    return props.message.content
  }
})

const messageType = computed(() => {
  if (['string', 'number'].includes(typeof data.value)) {
    return 'text'
  } else if (data.value.examples || data.value.questions) {
    return 'examples'
  } else if (data.value.wizardName) {
    return 'wizard'
  }
  return undefined
})

const handleClickExample = (message: string) => {
  emit('click:example', message)
}
</script>
